module.exports = __webpack_public_path__ + "img/maximize.f2c5c2d0.svg";